<template>
  <div class="news">
    <div class="news-hot news-li" :class="dataList.length ? '' : 'empty-back'">
      <div class="news-hot-list" v-if="dataList.length">
        <van-list v-model="loading" :finished="finished" finished-text="No more" @load="loadMore">
          <div v-for="(item, index) in dataList" :key="index" @click="LinkToNewsDetails({ item: item, user: userInfo })" class="news-hot-list-box">
            <!-- 第一个 -->
            <div class="news-hot-list-one hot-1" v-if="index == 0">
              <p>{{ item.title }}</p>
              <div class="one-img">
                <img :src="item.covers[0]" v-load="'oNewsBig'" v-if="item.covers[0]" />
                <img src="@/assets/img/empty.png" v-else />
              </div>
              <span>{{ item.publishAt || item.createAt | moment("YYYY/MM/DD") }}</span>
            </div>
            <!-- 3封面 -->
            <div class="news-hot-list-one hot-2" v-if="index != 0 && item.covers.length >= 2">
              <p>{{ item.title }}</p>
              <div class="img2">
                <div class="img-box" v-for="(img, idx) in item.covers.slice(0, 3)" :key="'c' + idx">
                  <img :src="img" v-load="'oNews'" />
                </div>
              </div>
              <span>{{ item.publishAt || item.createAt | moment("YYYY/MM/DD") }}</span>
            </div>
            <!-- 单封面 -->
            <div class="news-hot-list-one hot-4" v-if="index != 0 && item.covers.length == 1">
              <div class="hot-4-l">
                <p>{{ item.title }}</p>
                <span>{{ item.publishAt || item.createAt | moment("YYYY/MM/DD") }}</span>
              </div>
              <div class="hot-4-r">
                <img :src="item.covers[0]" v-load="'oNews'" v-if="item.covers[0]" />
                <img src="@/assets/img/empty.png" v-else />
              </div>
            </div>
            <!--0封面 -->
            <div class="news-hot-list-one hot-3" v-if="index != 0 && item.covers.length == 0">
              <p>{{ item.title }}</p>
              <span>{{ item.publishAt || item.createAt | moment("YYYY/MM/DD") }}</span>
            </div>
          </div>
          <div slot="loading" class="f-tac loading">
            <img src="@assets/img/new/icon-loading.png" />
            loading...
          </div>
          <div slot="finished" class="f-tac loading">It's the end~</div>
        </van-list>
      </div>
      <p v-else class="no-msg">No data！</p>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import gql from "graphql-tag";
export default {
  name: "news",
  data () {
    return {
      loading: false, //展商加载状态
      finished: false, //加载是否完成状态
      dataList: [], //供需列表
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      totalPages: 0,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
    NewsGql () {
      return gql`
        query queryArticleType($query: QueryInput!) {
          queryArticleType(query: $query) {
            hasNextPage
            pageIndex
            totalCount
            items {
              articleType
              author
              authorId
              commentCount
              content
              covers
              createAt
              externalUrl
              favoriteCount
              id
              introduction
              itemId
              keywords
              likeCount
              metadata
              publishAt
              shareCount
              status
              subtitle
              title
              updateAt
              userCount
              viewCount
            }
          }
        }
      `;
    },
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      LinkToNewsDetails: "linkTo/LinkToNewsDetails",
    }),
    init () {
      this.getDataList();
    },
    loadMore () {
      if (this.finished) return;
      this.pageIndex += 1;
      console.log(this.pageIndex, "当前加载的页面");
      this.getDataList();
    },
    getDataList () {
      let where = {
        Equal: {
          n: "itemId",
          v: this.exhibitionId,
        },
        Equal_isdeleted: {
          n: "isDeleted",
          v: false,
        },
      };
      let order = [
        { N: "topic", v: 0 },
        { N: "toppingIndex", v: 0 },
        { N: "publishAt", v: 0 },
      ];
      this.$apollo.addSmartQuery("queryArticleType", {
        query: this.NewsGql,
        variables: {
          query: {
            page: this.pageIndex,
            size: this.pageSize,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
        fetchPolicy: "network-only", // 清除缓存的数据，重新获取服务器数据
        result (res) {
          console.log(res, "头条");
          let data = JSON.parse(JSON.stringify(res));

          if (data && data.data.queryArticleType.items.length) {
            let currentList = data.data.queryArticleType.items;
            currentList.map((c) => {
              if (c.covers.indexOf("[") !== -1) {
                c.covers = JSON.parse(c.covers);
              } else {
                c.covers = [];
              }
              if (c.introduction && c.introduction.indexOf("[") !== -1) {
                c.introduction = JSON.parse(c.introduction);
              } else {
                c.introduction = [];
              }
            });
            if (this.pageIndex == 1) {
              this.dataList = currentList;
            } else {
              this.dataList = [...this.dataList, ...currentList];
            }
            this.$nextTick(() => {
              $("html , body").animate({ scrollTop: 1 }, 0, () => {
                $("html , body")
                  .stop()
                  .animate({ scrollTop: 0 }, 0);
              });
            });
            this.loading = false;
            if (!data.data.queryArticleType.hasNextPage) {
              this.finished = true;
            }
          }
        },
        error (error) {
          console.error(error, "error错误处理");
        },
      });
    },
    addview (id) {
      let body = {
        ItemId: this.exhibitionId,
        ExhibitionInformationId: id,
        UserId: this.user.Id,
      };
      this.$http.post("/api/exhibitioninformationview", body, this.$service.v2ApiHeader).then((res) => { 
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.news {
  &-li {
    background: #fff;
    border-top: 0.3rem solid #fff;
    h2 {
      padding: 15px;
      font-size: 15px;
      color: #333;
      font-weight: 600;
      display: flex;
      align-items: center;
      line-height: 1.2;
      i {
        width: 3px;
        height: 16px;
        background-color: #1890ff;
        margin-right: 5px;
        display: inline-block;
      }
    }
  }
  &-z-list {
    margin: 0 15px;
    &-one {
      border-bottom: 1px solid #e6e6e6;
      p {
        font-size: 0.28rem;
        line-height: 1.6;
        color: #222;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap; 
        margin: 8px 0 4px;
      }
      span {
        font-size: 0.22rem;
        color: #999;
        line-height: 1.2;
        display: inline-block;
        padding-bottom: 11px;
      }
    }
    &-one:last-child {
      border: none;
    }
    &-one:first-child {
      p {
        margin-top: -3px;
      }
    }
  }
  &-hot-list {
    margin: 0 15px;
    &-box {
      border-bottom: 1px solid #e6e6e6;
    }
    &-one {
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 0.28rem;
        line-height: 1.6;
        color: #222;
        margin: 8px 0 4px;
      }
      span {
        font-size: 0.22rem;
        color: #999;
        line-height: 1.2;
        display: inline-block;
        padding: 10px 0;
      }
      .one-img {
        width: 100%;
        padding-top: 66%;
        position: relative;
        img {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    &-box:last-child {
      border: none;
    }
    &-box:first-child {
      p {
        margin-top: -3px;
      }
    }
    .hot-2 {
      .img2 {
        display: flex;
        align-items: center; 
        .img-box {
          width: 30%;
          padding-top: 20%;
          position: relative;
          img {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .img-box:nth-of-type(2) {
          margin: 0 5%;
        }
      }
    }
    .hot-4 {
      display: flex;
      justify-content: space-between;
      padding: 8px 0 10px;
      &-l {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: calc(100% - 120px);
        p {
          font-size: 0.28rem;
          line-height: 1.6;
          color: #222;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
          margin: 0;
        }
        span {
          font-size: 0.22rem;
          color: #999;
          line-height: 1.2;
          padding: 0;
        }
      }
      &-r {
        width: 105px;
        height: 68px;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
  }
}

.empty-back {
  background: transparent !important;
}
</style>
